import PageLink from './PageLink';

export default PageLink;
